import { useCallback } from 'react';

const useAllowOnlyLetters = () => {
    const handleKeyDown = useCallback((event) => {
        const allowedKeys = [
            'Backspace',
            'Tab',
            'ArrowLeft',
            'ArrowRight',
            'Delete',
            'Enter',
            'Home',
            'End',
        ];
        const isLetterOrSpace = /^[a-zA-Z ]$/.test(event.key);
        const isAllowedKey = allowedKeys.includes(event.key);

        if (!isLetterOrSpace && !isAllowedKey) {
            event.preventDefault();
        }
    }, []);

    return handleKeyDown;
}

export default useAllowOnlyLetters;
